<template>
  <div class="rbox">
    <div class="card">
      <div class="logWrap">
        <div class="bannerCon">
          <md-field v-if="getRoute() == 'courseEdit'" class="courseInputBottomBorder">
            <label>编辑课程名</label>
            <md-input v-model="routeData.name"></md-input>
          </md-field>
          <span class="courseName" style="float: left" v-else>{{ routeData.name }} </span>
          <div
            class="share"
            :style="{
              float:
                (routeData.name && routeData.name.length > 15) || isMobile.isMobile
                  ? 'left !important'
                  : 'right !important',
              marginLeft: routeData.name && routeData.name.length > 15 ? '13px' : '',
            }"
          >
            <ul class="linkmore">
              <li>
                <span>分享</span>
              </li>
              <li>
                <svg class="icon" aria-hidden="true" @click="shareToMicroblog('qq')">
                  <use xlink:href="#icon-QQ" />
                </svg>
              </li>
              <li>
                <svg class="icon" aria-hidden="true" @click="shareToMicroblog('weibo')">
                  <use xlink:href="#icon-shejiaotubiao-42" />
                </svg>
              </li>
              <li>
                <svg class="icon" aria-hidden="true" @click="shareToMicroblog('weixin')">
                  <use xlink:href="#icon-weixin" />
                </svg>
              </li>
            </ul>
          </div>
        </div>
        <div class="log">
          <!-- getuserLog -->
          <img
            :src="userLogin ? userLogin : require('../../../assets/img/courseMessage.png')"
            style="width: 60px; height: 60px; border-radius: 50px"
            alt=""
          />
          <p :class="isdes ? '' : 'classDes'" style="display: inline-block">
            开发教师：{{ routeData.creater }}
          </p>
        </div>
      </div>

      <p :class="isdes ? '' : 'classDes'">参与院校：{{ routeData.university }}</p>
      <p :class="isdes ? '' : 'classDes'" class="courseJieSao" v-if="getRoute() == 'courseEdit'">
        课程介绍：
        <md-field style="margin-top: 0px" class="md-fieldWrap">
          <md-textarea v-model="routeData.description" style="border-color: red"></md-textarea>
        </md-field>
      </p>

      <p :class="isdes ? '' : 'classDes'" class="courseJieSao" v-else>
        课程介绍：
        <md-content class="md-scrollbar">{{ routeData.description }}</md-content>
        <!-- <md-tooltip md-direction="top" class="toopZindex">{{routeData.description }}</md-tooltip> -->
      </p>
    </div>
    <div class="tagWrap">
      <!-- <p style="font-size: 13px; margin: 0px">标签</p> -->
      <v-select
        v-if="getRoute() == 'courseEdit'"
        v-model="routeData.tag"
        :items="tagAlls"
        label="标签"
        multiple
        chips
        persistent-hint
        item-color="green"
        item-text="label"
        item-value="value"
      ></v-select>
      <v-select
        v-else
        :items="tagList"
        v-model="selectedItem"
        variant="outlined"
        class="selecttag"
        style="color: #fff; text-transform: none"
        @change="(val) => $store.commit('courseAndProject/SET_SIMULATION_PLATFORM', val)"
      >
        <template v-slot:append-outer>
          <v-btn
            color="rgb(76, 175, 80)"
            @click="openClientDetail(selectedItem)"
            style="color: #fff; text-transform: none"
          >
            {{ returnIcon(selectedItem).name }}
          </v-btn>
        </template>
      </v-select>
    </div>
    <div class="classBanner">
      <el-tooltip content="学习时长" placement="top" effect="light">
        <div class="infoItem">
          <div class="infoItem-title"><span class="iconfont icon-jilu"></span></div>
          <div class="infoItem-data">{{ formattedTime }}分</div>
        </div>
      </el-tooltip>
      <div class="bar"></div>
      <el-tooltip content="点赞数量" placement="top" effect="light">
        <div class="infoItem">
          <div class="infoItem-title"><span class="iconfont icon-dianzan_kuai"></span></div>
          <div class="infoItem-data">0</div>
        </div>
      </el-tooltip>
      <div class="bar"></div>
      <el-tooltip content="预览次数" placement="top" effect="light">
        <div class="infoItem">
          <div class="infoItem-title">
            <span class="iconfont icon-yulan4" style="font-size: 18px"></span>
          </div>
          <div class="infoItem-data">{{ routeData.browseNumber }}</div>
        </div>
      </el-tooltip>
      <div class="bar"></div>
      <el-tooltip content="留言" placement="top" effect="light">
        <div class="infoItem">
          <div class="infoItem-title"><span class="iconfont icon-msg"></span></div>
          <div class="infoItem-data">
            <animated-number :value="messageTotal" :key="messageTotal"></animated-number>
          </div>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
import {
  getbyIdQueryUser,
  sendTime,
  simulationParams,
} from '@/api/simulation';
import { AnimatedNumber } from '@/components';
import { mapGetters } from 'vuex';
import 'video.js/dist/video-js.css';
import moment from 'moment';
import { openUrlWithInputTimeoutHack } from '../Class/arouse';
import { ossMultipartUpload } from '@/api/common'

export default {
  props: {
    routeData: {
      type: Object,
      default: null,
    },
    getMesageTitolValue: {
      type: Number,
      default: 0,
    },
  },
  components: {
    AnimatedNumber,
    // Modal,
    // courseDetail,
  },
  watch: {
    routeData: {
      handler(news) {
        if (news) {
          this.getbyIdQueryUser(news);
          this.setCourseBrowse(news);

          if (this.isMobile.isMobile) {
            this.selectedItem = 'Android';
          } else {
            this.selectedItem = 'PC';
          }
        }
        // this.setCourseBrowse()
        if (news.description !== '') {
          this.isdes = true;
        } else {
          this.isdes = false;
        }
        this.$store.commit('courseAndProject/SET_SIMULATION_PLATFORM', this.selectedItem)
      },
      deep: true,
    },
    getMesageTitolValue: {
      handler(news) {
        this.messageTotal = news;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['courseList', 'cardType', 'courseListPage', 'course', 'isMobile', 'user']),
    formattedTime() {
      return this.totalMinutes; // 直接显示分钟数
    },
    player() {
      return this.$refs.videoPlayer.player;
    },
    tagList() {
      let list = []
      if (this.routeData.publishType === 'soft') {
        if (!this.routeData.softInfo || !this.routeData.softInfo.softVersions) return []
        list = this.routeData.softInfo.softVersions.flatMap(item => item.platform)
      } else {
        list = this.routeData.tag;
      }
      if (list && list.length > 0) {
        this.selectedItem = list[0]
      }
      return list
    }
  },
  data() {
    return {
      inputTheme: {
        primary: '#fff', // 你希望下拉线的颜色
        accent: 'pink', // 其他颜色，如果需要
      },
      selectedItem: 'PC',
      timer: null,
      totalMinutes: 0, // 总分钟数
      messageTotal: 0, //留言
      isdes: false,
      userLogin: '',
      tags: [],

      imgList: [], // 因为这是mock过来的，所以这里是空数组

      relatedTreeData: [],
      //   routeData: {},

      thumbsSwiper: null,

      tagAll: [
        {
          type: 'PC',
          url: '../../../w10.png',
          name: '打开PC版本',
        },
        {
          type: 'VR',
          url: '../../../vr.png',
          name: '打开VR版本',
        },
        {
          type: 'WebGL',
          url: '../../../webGL.png',
          name: '打开WebGL版本',
        },
        {
          type: 'Android',
          url: '../../../az.png',
          name: '打开安卓版本',
        },
        {
          type: 'ZSpace',
          url: '../../../zspace.png',
          name: '打开ZSpace',
        },
        {
          type: 'KMAX',
          url: '../../../km.png',
          name: '打开KMAX版本',
        },
        {
          type: 'standalone',
          url: '../../../dr.png',
          name: '单机模式',
        },
      ],
      tagAlls: [
        {
          label: 'PC',
          value: 'PC',
        },
        {
          label: 'VR',
          value: 'VR',
        },
        {
          label: 'WebGL',
          value: 'WebGL',
        },
        {
          label: '安卓',
          value: 'Android',
        },
        {
          label: 'ZSpace',
          value: 'ZSpace',
        },
        {
          label: 'KMAX',
          value: 'KMAX',
        },
        {
          label: '单机模式',
          value: 'standalone',
        },
      ],
      startTime: 0,
      endTime: 0,
      browseNumber: 0,
      learningTime: 0,
    };
  },
  onmounted() {
    
  },
  methods: {
    performAction() {
      this.openClientDetail(this.selectedItem);
    },
    returnIcon(it) {
      let obj = {
        url: null,
        name: null,
      };
      this.tagAll.forEach(item => {
        if (item.type == it) {
          obj.url = item.url;
          obj.name = item.name;
        }
      });
      return obj;
    },
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    getRoute() {
      // courseView //查看    courseEdit 编辑
      let route = null;
      if (this.$route.query && this.$route.query.courseType) {
        route = this.$route.query.courseType;
      }
      return route;
    },

    //分享
    shareToMicroblog(type) {
      //跳转地址
      let url = encodeURIComponent('http://meta-v4.icubespace.com/');
      let title = encodeURIComponent('元世界.自动化教学设计平台');
      switch (type) {
        case 'weixin':
          break;

        case 'weixinkongjian':
          this.getShareInfo();
          break;

        case 'qq':
          window.open(
            `https://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${title}&source=${url}&desc=${title}&pics=`
          );
          break;

        case 'qqkongjian':
          window.open(
            `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${title}&summary=${title}&site=${url}`
          );
          break;

        case 'weibo':
          window.open(`https://service.weibo.com/share/share.php?url=${url}&title=${title}`);
          break;
      }
    },

    // vue调用微信的自定义分享
    getShareInfo() {},

    //打开客户端
    async openClientDetail(platform = 'PC') {
      const { data } = await simulationParams({
        _id: this.routeData._id,
        platform,
        runtime: process.env.VUE_APP_RUNTIME,
        studyMode: 'study'
      })

      const { url, softDownloadUrl } = data

      if ('WebGL' === platform) {
        window.open(url, '_blank');
        return;
      }

      openUrlWithInputTimeoutHack(
        url,
        () => {
          const res = confirm('应用程序未安装,请下载并安装');
          if (res) {
            window.location.href = softDownloadUrl; // window.open会被浏览器拦截,使用window.location.href下载exe
          }
        },
        () => {
          console.log('已安装，自动唤起');
        }
      );
    },

    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    //跳转页面

    // async querydetailList() {
    //   if (this.$route.query._id) {
    //     let res = await getdetailList({ _id: this.$route.query._id });

    //     if (!res.data) return;
    //     this.routeData = res.data;
    //   }
    // },

    // getuserLog() {
    //   let avatar = '';
    //   if (window.localStorage.getItem('USER_INFO')) {
    //     avatar = JSON.parse(window.localStorage.getItem('USER_INFO')).user.avatar;
    //   }
    //   return avatar;
    // },
    //根据课程创建人去获取用户信息
    getbyIdQueryUser(data) {
      let params = {
        _id: data.courseCreateId || '',
      };
      if (!params._id) {
        return;
      }
      getbyIdQueryUser(params).then(res => {
        if (res.code == '200') {
          this.userLogin = res.data.avatar;
        }
      });
    },

    setCourseBrowse(mews) {
      this.browseNumber = mews.browseNumber + 1; // this.routeData.browseNumber+1
      this.loadTimeFromStorage(mews);
      // let date =  mews.learningTime.split('_')
      // console.log(date[0])
      // console.log(date[1])
      // console.log(date[2])
      // if(date[0]>0){
      //   this.learningTime = date[0]

      // }else if(date[1]>0){
      //   this.learningTime = date[1]
      // }if(date[2]>0){
      //   this.learningTime = date[2]
      // }
      this.startTime = new Date().getTime();
    },
    endCourseBrowse() {
      // var endTime = new Date().getTime();
      // var timeSpent = endTime - parseInt(this.startTime);
      // var seconds = Math.floor(timeSpent / 1000);
      // var hours = Math.floor(seconds / 3600);
      // var minutes = Math.floor((seconds % 3600) / 60);
      // seconds = seconds % 60;
      // console.log(
      //   '您在页面上停留的时间是：' + hours + '小时 ' + minutes + '分钟 ' + seconds + '秒。'
      // );

      let obj = {
        browseNumber: this.browseNumber,
        learningTime: this.totalMinutes,
        id: this.routeData._id || '',
      };
      return obj;
    },

    sendTime() {
      let { id, browseNumber, learningTime } = this.endCourseBrowse();
      sendTime({ browseNumber, learningTime, id }).then(res => {
        // console.log(res, '111111111111');
      });
    },
    loadTimeFromStorage(data) {
      const storedTime = data.learningTime;
      if (storedTime) {
        this.totalMinutes = parseInt(storedTime, 10);
      }
    },
    startTiming() {
      this.timer = setInterval(() => {
        this.totalMinutes++;
      }, 60000); // 更新时间为每分钟一次
    },
    stopTiming() {
      clearInterval(this.timer);
      this.timer = null;
    },
    stopTimingAndSendData() {
      this.stopTiming();
      // this.sendDataToBackend(this.totalMinutes);
      // localStorage.setItem('totalMinutes', this.totalMinutes.toString()); // 存储到本地
    },
  },
  destroyed() {
    this.sendTime();
  },
  mounted() {
    // this.loadTimeFromStorage();
    this.startTiming();
    window.addEventListener('beforeunload', this.stopTimingAndSendData);

    // this.querydetailList();

    // let content = document.getElementsByClassName('content')[0];
    // let header = document.getElementsByClassName('md-toolbar')[0].clientHeight;
    // let footer = document.getElementsByClassName('footer')[0].clientHeight;
    // let client = document.body.clientHeight - header - footer;
    // content.style.cssText = `height:auto; min-height:${client}px;overflow-y:scoll`;
    // if (this.$route.query.type && this.$route.query.type == 'home') {
    //   let timer = setTimeout(() => {
    //     let dashboardIdMenu = document.getElementById('dashboardIdMenu');
    //     if (dashboardIdMenu) {
    //       let dashboardIdMenu = document.getElementById('dashboardIdMenu');
    //       dashboardIdMenu.style.cssText =
    //         'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
    //       clearTimeout(timer);
    //     }
    //   }, 400);
    // }

    // if (this.$route.query.type && this.$route.query.type == 'simclass') {
    //   let timer = setTimeout(() => {
    //     let simclassIdMenu = document.getElementById('simclassIdMenu');
    //     if (simclassIdMenu) {
    //       let simclassIdMenu = document.getElementById('simclassIdMenu');
    //       simclassIdMenu.style.cssText =
    //         'background-color:#4caf50;box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);';
    //       clearTimeout(timer);
    //     }
    //   }, 400);
    // }
  },
  beforeDestroy() {
    this.stopTimingAndSendData();
  },

  created() {
    this.getRoute();
    let _this = this;
  },
};
</script>

<style>
@media (max-width: 599px) {
  .footer .container nav ul li > a {
    padding: 5px 10px;
  }
}
</style>
<style lang="scss" scoped>
.md-content {
  max-height: 130px;
  height: 130px;
  overflow: auto;
}
.rbox {
  width: 30%;
  float: right;
  overflow: hidden;
  .card {
    font: 15px 'Microsoft YaHei', Arial, Helvetica, sans-serif;
    color: #333;
    line-height: 1.5;
    margin: 0;
    padding: 0;
    border-radius: 3px;
    height: 280px;
    overflow: hidden;
    margin-bottom: 10px;
    h2 {
      font-size: 22px;
      margin: 10px;
      color: #89919a;
      font-weight: normal;
      padding-bottom: 10px;
    }
    p {
      font-size: 12px;
      padding: 0 0 0 20px;
      line-height: 28px;

      color: #000;
      margin: 0;
    }
  }
}
.linkmore {
  // margin: 15px;
  overflow: hidden;
  // margin-left: 21px;
}

.linkmore li {
  width: 30px;
  float: left;
  height: 30px;
  line-height: 30px;
  display: block;
  overflow: hidden;
  border-radius: 50%;
  margin: 0 5px;
  text-align: center;
  cursor: pointer;
}
.linkmore li:first-child {
  box-shadow: none;
  border-radius: 0;
}
.icon {
  width: 1.8em;
  height: 1.8em;
  vertical-align: middle;
  fill: currentColor;
  overflow: hidden;
  transition: 0.3s;
}
ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.logWrap {
  width: 100%;
  height: auto;
  overflow: hidden;
  .log {
    float: left;
    padding: 5px 20px;
  }
  .share {
    float: left;
    padding: 0px;
  }
}

.tagWrap {
  min-height: auto;
  width: 100%;
  border-radius: 3px;
  overflow: hidden;
  background-color: #fff;
  padding: 0 17px;
  z-index: 999999;
}

.courseJieSao {
  width: 468px;
  line-height: 20px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 媒体查询 - 针对小屏幕设备 */
@media (max-width: 1300px) {
  .linkmore {
    margin-left: 0px;
  }
  .courseJieSao {
    width: 406px;
  }
}

/* 媒体查询 - 针对小屏幕设备 */
@media (max-width: 1200px) {
  .linkmore li {
    width: 34px;
  }
  .linkmore {
    margin-left: 0px;
  }
  .courseJieSao {
    width: 340px;
  }
  .logWrap .log {
    float: left;
    padding: 5px;
  }
  // .lbox{
  //   width: 40%;
  // }
}

/* 媒体查询 - 针对小屏幕设备 */
@media (max-width: 1190px) {
  .linkmore {
    margin-left: 0px;
  }
  .courseJieSao {
    width: 368px;
  }
  // .lbox{
  //   width: 40%;
  // }
}

/* 媒体查询 - 针对小屏幕设备 */
@media (max-width: 1060px) {
  .linkmore {
    margin-left: 0px;
  }
  .courseJieSao {
    width: 340px;
  }
  // .lbox{
  //   width: 40%;
  // }
}

/* 媒体查询 - 针对小屏幕设备 */
@media (max-width: 1030px) {
  .logWrap .log {
    padding: 5px;
  }
  .share {
    padding: 10px 0px;
  }
  .linkmore {
    margin-left: 0px;
  }
  .courseJieSao {
    width: 240px;
  }
  // .lbox{
  //   width: 40%;
  // }
}

@media (max-width: 950px) {
  .wrap .lbox {
    width: 100% !important;
  }
  .wrap .rbox {
    width: 100% !important;
    float: none !important;
  }
  .logWrap .share {
    float: right !important;
  }
  .courseJieSao {
    width: 96%;
  }

  .logWrap .log {
    padding: 5px;
    padding-left: 20px;
  }
}

@media (max-width: 407px) {
  .logWrap .log {
    padding: 5px;
  }
  .logWrap .share {
    padding: 0px;
  }
}
// @media (max-width: 950px) {
//   article {
//     width: 800px !important;
//   }
//   .courseJieSao{
//     width: 780px;
//   }
//   .logWrap .share{
//     float: right !important;
//   }
// }
.openBtn {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  image-rendering: -webkit-optimize-contrast;
  display: block;
  float: left;
  border-radius: 5px;
  padding: 2px;
  margin: 3px;
  background: rgb(34 124 96);
  cursor: pointer;
  // transform: scale(0.8);
  z-index: 999;
}

.classBanner {
  border-radius: 3px;
  background-color: #d8d8d84f;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  color: #ffffff;

  width: 100%;
  height: 68px;
  margin-top: 21px;
}

.infoItem {
  padding: 7px;
  font-size: 14px;
  text-align: center;
  color: #a19f9f;
  width: 25%;
  cursor: pointer;
}
.bar {
  height: calc(100% - 40px);
  width: 1px;
  background-color: #fff;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  position: relative;
  top: 50%;
}

.infoItem-title {
  //margin-bottom: 8px;
}
.infoItem-data {
  font-size: 17px;
  font-family: DIN;
  font-weight: 700;
}

.infoItem-title span {
  font-size: 17px;
}

.classDes {
  line-height: 58px !important;
}

.v-application .primary--text {
  color: rgb(76, 175, 80) !important;
  caret-color: rgb(76, 175, 80) !important;
}

.v-select {
  text-transform: uppercase;
}

.md-field.md-has-textarea:not(.md-autogrow):before {
  border-bottom: 2px solid transparent !important;
  border-color: rgb(76, 175, 80) !important;
  // transform: scaleX(0.12);
}

.md-fieldWrap .md-textarea {
  padding-top: 0px !important;
}

.bannerCon {
  height: auto;
  overflow: hidden;
}
.bannerCon > span {
  font-size: 20px;
  color: #333333;
  margin-right: 8px;
  font-weight: 600;
  padding-left: 20px;
  line-height: 35px;
}

.bannerCon .courseInputBottomBorder::before {
  background-color: rgb(76, 175, 80) !important;
}

@media (max-width: 600px) {
  .bannerCon .courseName {
    font-size: 16px;
    padding-left: 10px;
  }

  .logWrap .share {
    padding: 0px;
  }

  .logWrap {
    margin-bottom: 5px;
  }
  .card p {
    padding: 0 0 0 10px !important;
  }
  .classBanner {
    width: 96%;
    margin: 0 auto;
  }

  .share .linkmore li {
    width: 30px;
    height: 35px;
    line-height: 35px;
    .icon {
      width: 1.5em;
    }
  }
  .logWrap .log {
    // width: 50px;
    height: 60px;

    img {
      width: 40px !important;
      height: 40px !important;
    }
  }
}
</style>
